import React from 'react';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
import { useTranslations } from '../../locales/useTranslations';

const BlogPagination = ({ 
    currentPage, 
    totalPages, 
    onPageChange 
}) => {
    const { t } = useTranslations();
    
    const effectiveTotalPages = Math.max(1, totalPages);
    
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (effectiveTotalPages <= maxVisiblePages) {
            for (let i = 1; i <= effectiveTotalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);
            
            if (currentPage > 3) {
                pages.push('...');
            }
            
            const start = Math.max(2, currentPage - 1);
            const end = Math.min(effectiveTotalPages - 1, currentPage + 1);
            
            for (let i = start; i <= end; i++) {
                if (!pages.includes(i)) {
                    pages.push(i);
                }
            }
            
            if (currentPage < effectiveTotalPages - 2) {
                pages.push('...');
            }
            
            if (!pages.includes(effectiveTotalPages)) {
                pages.push(effectiveTotalPages);
            }
        }
        
        return pages;
    };
    
    const pageNumbers = getPageNumbers();

    return (
        <div className="blog-pagination">
            {/* Previous Button */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`blog-pagination-btn ${currentPage === 1 ? 'disabled' : 'nav'}`}
                aria-label={t('blog_pagination_prev')}
            >
                <BiChevronLeft />
            </button>
            
            {/* Page Numbers */}
            {pageNumbers.map((page, index) => (
                page === '...' ? (
                    <span key={`ellipsis-${index}`} className="blog-pagination-ellipsis">
                        ...
                    </span>
                ) : (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`blog-pagination-btn ${currentPage === page ? 'active' : 'inactive'}`}
                    >
                        {page}
                    </button>
                )
            ))}
            
            {/* Next Button */}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === effectiveTotalPages}
                className={`blog-pagination-btn ${currentPage === effectiveTotalPages ? 'disabled' : 'nav'}`}
                aria-label={t('blog_pagination_next')}
            >
                <BiChevronRight />
            </button>
        </div>
    );
};

export default BlogPagination;
